import _ from 'lodash'
import packageJson from '../package.json'

/**
 * Tweak the global window definition so that it allows for the configuration elements
 * we will inject from the origin
 */
declare global {
  interface Window {
    __env__: { [key: string]: any }
    __features__: { [key: string]: any }
  }
}

/**
 * Function that is called *prior* to application startup in order to load any dynamic (i.e. environmental)
 * configuration settings from the origin server. This is an alternative solution to using "baked in" configuration
 * values written into the bundles at compile time.
 *
 * The purpose of taking this approach is so that the site hosting the SPA can dynamically alter the configuration of
 * the loaded SPA through *runtime configuration* only, so that only a single build of the SPA is required, rather than
 * the previous build-per-environment approach.
 *
 * When running inside of a container, the container runtime can substitute in alternate configuration values through
 * things like volume mounts, ConfigMaps etc...
 */
export async function loadConfigurationFromOrigin() {
  await fetch('/config.json')
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
    })
    .then((json) => {
      console.debug('Setting environment')
      const env: { [key: string]: any } = {}
      const features: { [key: string]: any } = {}
      // deal with environment variables
      if (_.has(json, 'env')) {
        const keys = Object.keys(json.env)
        keys.forEach((key) => {
          env[key] = json.env[key]
        })

        // add the version from the current package.json
        env['VERSION'] = packageJson.version
        if (env['TENANT_ID'] === undefined) env['TENANT_ID'] = "local"


        window.__env__ = Object.freeze(env)
        console.log(window.__env__)
      }

      // deal with feature flag variables
      if (_.has(json, 'features')) {
        const keys = Object.keys(json.features)
        keys.forEach((key) => {
          features[key] = json.features[key]
        })

        // check for the existence of a hubspot override flag and set the default
        // we don't actually care what the value here is in here, we just doing an existence check
        if (features['HUBSPOT_DISABLED'] === undefined) {
          features['HUBSPOT_DISABLED'] = false
        } else {
          features['HUBSPOT_DISABLED'] = true
        }

        window.__features__ = Object.freeze(features)
        console.log(window.__features__)
      } else {
        features['HUBSPOT_DISABLED'] = false
        window.__features__ = Object.freeze(features)
        console.log(window.__features__)
      }
    })
}
